import React from 'react'
import VipLayout from '../../../components/vip/VipLayout'

const TrainingAndFinetuningPage: React.FC = () => {
  return (
    <VipLayout>
      <section className="hero">
        <div className="container">
          <span className="kicker">Training & Fine-tuning</span>
          <h1>企业知识库训练与微调解决方案</h1>
          <p>围绕企业文档、FAQ、产品资料、业务 SOP、客服话术、行业知识等数据资产，帮助企业建立更适合自身业务场景的知识中枢与模型能力。</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid cols-3">
            <div className="card content-card">
              <h3>知识资料梳理</h3>
              <p className="lead" style={{fontSize: '15px'}}>先把企业数据从分散状态转成可治理、可索引、可训练的结构。</p>
            </div>
            <div className="card content-card">
              <h3>RAG / 微调路径判断</h3>
              <p className="lead" style={{fontSize: '15px'}}>不是所有场景都需要重训练，先判断知识库增强与微调的边界。</p>
            </div>
            <div className="card content-card">
              <h3>数据合规与训练边界</h3>
              <p className="lead" style={{fontSize: '15px'}}>围绕数据来源、脱敏、标注、测试与输出风险建立可持续治理框架。</p>
            </div>
          </div>
        </div>
      </section>
    </VipLayout>
  )
}

export default TrainingAndFinetuningPage
